import React from 'react';
import { useBreadcrumbAction, useUserAction } from 'store';
import MessageAlert, { deleteCookie, DEPLOY_TYPE, DOMAIN_URL } from 'utils';

const PrivateRoute = ({ children, auth, path }) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const breadcrumbAction = useBreadcrumbAction();
  const userAction = useUserAction();

  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /**
   * 헤더 상단 Breadcrumb 설정
   * --
   */
  React.useEffect(() => {
    if (path) breadcrumbAction.push(path);
  }, [breadcrumbAction, path]);

  /**
   * 접근 권한 체크
   * --
   */
  React.useLayoutEffect(() => {
    const userInfo = userAction.getUser();

    if (auth && userInfo && auth !== userInfo.type) {
      // console.log('auth', auth);
      // console.log('userInfo.type', userInfo.type);
      userAction.resetUser();
      deleteCookie('JM_COFFEE_ACCESS_TOKEN', {});
      MessageAlert.warning('접근 권한이 없습니다');
      const protocol = window.location.protocol;
      const port = DEPLOY_TYPE === 'local' ? ':3000' : '';

      const domain =
        DEPLOY_TYPE === 'development'
          ? `mall-${DOMAIN_URL}`
          : `mall.${DOMAIN_URL}`;

      return (window.location.href = `${protocol}//${domain}${port}/#/admin`);
    }
    // eslint-disable-next-line
  }, [auth]);

  //   return false;

  /* ===== Render ===== */
  return children;
};

export default PrivateRoute;
